import { computed, unref } from 'vue'
import {
  DYNAMIC_CREATIVE_TYPE,
  DELIVERY_MODE
} from '@/views/create/gdt/model/creative-const.js'
import { MATERIAL_TYPE } from '@/components/material-selector/consts.js'

import { SITE_ENUM } from '../../../model/siteset/siteset-const.js'

export const getCarouselMaterialType = (creativeForm = {}) => {
  const { delivery_mode, dynamic_creative_type, creative_template_id } = creativeForm
  const isManualCreative =
    [DELIVERY_MODE.CUSTOMIZE, DELIVERY_MODE.COMPONENT].includes(delivery_mode) &&
    dynamic_creative_type === DYNAMIC_CREATIVE_TYPE.COMMON

  if (!isManualCreative) return ''
  if (creative_template_id === 2688) return MATERIAL_TYPE.IMAGE
  if (creative_template_id === 2888) return MATERIAL_TYPE.VIDEO
  return ''
}

export const useGdtCreativeComputes = (creativeForm, planForm) => {
  /**
   * @description: 【图文链接】【朋友圈文字链】和【礼包组件】 互斥规则
   * @param {*} computed
   * @return {*}
   */
  const componentsDisabled = computed(() => {
    const { app_gift_pack_code, mini_card_link, text_link, wxgame_playable_component } = unref(creativeForm).components || {}
    // 互斥规则：【图文链接】【朋友圈文字链】 【小游戏试玩】和【礼包组件】只能4选1打开，不能够同时打开。
    return {
      // 朋友圈文字链
      textLink: app_gift_pack_code?.switch || mini_card_link?.switch || wxgame_playable_component?.switch,
      // 礼包组件
      appGiftPackCode: mini_card_link?.switch || text_link?.switch || wxgame_playable_component?.switch,
      // 图文链接
      miniCardLink: app_gift_pack_code?.switch || text_link?.switch || wxgame_playable_component?.switch,
      // 组件化创意的自定匹配试玩营销组件
      wxgamePlayable: app_gift_pack_code?.switch || mini_card_link?.switch || text_link?.switch
    }
  })

  const isManualCreative = computed(() => {
    const { delivery_mode, dynamic_creative_type } = unref(creativeForm)
    if (delivery_mode === DELIVERY_MODE.CUSTOMIZE || delivery_mode === DELIVERY_MODE.COMPONENT) {
      return dynamic_creative_type === DYNAMIC_CREATIVE_TYPE.COMMON
    }
    return false
  })

  /**
   * @description: 手动匹配选择激励浏览计划时认为是可试玩游戏
   * @param {*}
   * @return {*}
   */
  const isWxGamePlayable = computed(() => {
    return isManualCreative.value && unref(creativeForm).creative_template_id === 910
  })

  const isCarouselThreeImage = computed(() => {
    return getCarouselMaterialType(unref(creativeForm)) === MATERIAL_TYPE.IMAGE
  })

  const isCarouselThreeVideo = computed(() => {
    return getCarouselMaterialType(unref(creativeForm)) === MATERIAL_TYPE.VIDEO
  })

  const carouselMaterialType = computed(() => {
    return getCarouselMaterialType(unref(creativeForm))
  })

  /**
   * @description: 组件化创意及自动配时是否显示试玩游戏营销组件
   * @param {*}
   * @return {*}
   */
  const showWxGamePlayableComponent = computed(() => {
    // 包含朋友圈版位或者是自动版位
    return unref(planForm).siteSet.includes(SITE_ENUM.MOMENTS) || unref(planForm).automatic_site_enabled
  })

  return {
    componentsDisabled,
    isManualCreative,
    // 自定义创意的手动匹配创意形式的试玩
    isWxGamePlayable,
    isCarouselThreeImage,
    isCarouselThreeVideo,
    carouselMaterialType,
    showWxGamePlayableComponent
  }
}
